import React from 'react';
import PageHeader from '../components/PageHeader';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';

const PUB = process.env.PUBLIC_URL;

function AboutPage() {
  return (
    <>
      <PageHeader
        eyebrow="About Ron"
        title="A Big Flats Family. A Lifetime of Work."
        lead="Ron Johanson’s family put down roots in Big Flats more than a century ago. He’s built businesses, run gravel pits, raised a family, and learned how small towns actually work."
      />

      <section className="section">
        <div className="container about-page__grid">
          <Reveal as="div" variant="left" className="about-page__body">
            <p>
              Ron&rsquo;s grandparents moved to Big Flats from Elmira in 1919,
              and the family has called it home ever since. After studying at
              Northeastern University, Ron returned to the area to raise his
              three sons with his wife Danielle.
            </p>
            <p>
              For more than two decades, Ron has managed small businesses
              &mdash; most recently a network of gravel pits regulated by
              MSHA, the DEC, and a host of other agencies. He owned and
              operated his own business for 12 years. He knows what it means
              to make payroll, answer to neighbors, and get a job done right.
            </p>
            <p>
              That experience shapes how Ron approaches problems. As he puts
              it: &ldquo;I just look at a problem and I don&rsquo;t see
              roadblocks. I simply see a way to solve the problem and push
              through.&rdquo;
            </p>
            {/* <p>
              Ron also served briefly on the Big Flats Planning Board. He
              stepped away when work pressures made it impossible to give the
              role the time it deserved &mdash; and walked away convinced that
              real impact required stepping up to a higher role.
            </p> */}
          </Reveal>

          <Reveal as="aside" variant="right" className="about-page__sidebar">
            <figure className="about-page__portrait">
              <img src={`${PUB}/media/ron-portrait.jpg`} alt="Ron Johanson" />
            </figure>
            <h3>By the Numbers</h3>
            <div className="about__stats about__stats--stacked">
              <div className="stat">
                <div className="stat__num">107</div>
                <div className="stat__label">Years his family has called Big Flats home</div>
              </div>
              <div className="stat">
                <div className="stat__num">30</div>
                <div className="stat__label">Years of marriage to Danielle Sujko Johanson</div>
              </div>
              <div className="stat">
                <div className="stat__num">25+</div>
                <div className="stat__label">Years managing small businesses</div>
              </div>
              <div className="stat">
                <div className="stat__num">12</div>
                <div className="stat__label">Years owning his own business</div>
              </div>
              <div className="stat">
                <div className="stat__num">10</div>
                <div className="stat__label">Years working in the gas industry</div>
              </div>
              <div className="stat">
                <div className="stat__num">3</div>
                <div className="stat__label">Sons raised right here</div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}

export default AboutPage;
